<svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 12 12"
>
    <path
        fill="currentColor"
        d="M1.11652 3.1204C1.30891 2.94718 1.6053 2.96271 1.77853 3.1551L6.0059 7.85006L10.2333 3.1551C10.4065 2.96271 10.7029 2.94718 10.8953 3.12041C11.0876 3.29363 11.1032 3.59002 10.9299 3.78241L6.37171 8.84486C6.27496 8.9523 6.1398 9.00459 6.00579 8.99963C5.87185 9.00453 5.73678 8.95224 5.64008 8.84485L1.08183 3.78241C0.908604 3.59002 0.924137 3.29363 1.11652 3.1204Z"
    />
</svg>